var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupe3413(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.885,
    height: 124,
    viewBox: "0 0 60.885 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3413",
    "data-name": "Groupe 3413",
    transform: "translate(-2204.843 -5.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11687",
    "data-name": "Trac\\xE9 11687",
    d: "M3189.812,736.471c.644,0,1.013.852.826,1.9s-.86,1.9-1.5,1.9-1.013-.852-.826-1.9.86-1.9,1.5-1.9Zm-9.408,0c-.644,0-1.013.852-.826,1.9s.86,1.9,1.5,1.9,1.013-.852.826-1.9S3181.047,736.471,3180.4,736.471Z",
    transform: "translate(-928.137 -695.675)",
    fill: "#f0b376",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11688",
    "data-name": "Trac\\xE9 11688",
    d: "M2868.449,905.523h-1.187a5.333,5.333,0,0,0-3.671,1.464l-6.687.6.6,4.071.933,2.275,9.162-.768Z",
    transform: "translate(-620.92 -856.654)",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11689",
    "data-name": "Trac\\xE9 11689",
    d: "M2598.585,1812.8c10.434,4.291,17.187,17.057,17.187,24.771s-6.753,8.643-17.187,12.934c-10.434-4.291-17.187-5.22-17.187-12.934S2588.151,1817.093,2598.585,1812.8Z",
    transform: "translate(-358.571 -1720.603)",
    fill: "#f66",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11690",
    "data-name": "Trac\\xE9 11690",
    d: "M2715.955,2060.047c5.617,0,10.2-2.221,10.2-4.944s-4.582-4.944-10.2-4.944-10.2,2.221-10.2,4.944S2710.338,2060.047,2715.955,2060.047Z",
    transform: "translate(-476.991 -1946.624)",
    fill: "#f24e4e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11691",
    "data-name": "Trac\\xE9 11691",
    d: "M2687.971,1986.983l-2.847-.106c-2.887-.108-4.912,1.8-3.825,4.788a1.9,1.9,0,0,0,1.888,1.21q1.706.02,3.369.143a4.363,4.363,0,0,0,3.781-2.416l-1.417-3.391Z",
    transform: "translate(-453.417 -1886.36)",
    fill: "#fc9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11692",
    "data-name": "Trac\\xE9 11692",
    d: "M2739.285,2116.236l-1.985,2.044a15.415,15.415,0,0,1-2.844,2.326,1.4,1.4,0,0,0-.509,1.261,1.191,1.191,0,0,0,.654,1.1q1.858.613,3.7,1.356a1.9,1.9,0,0,0,2.163-.592q1.157-1.254,2.362-2.407a4.364,4.364,0,0,0,.736-4.425l-3.468-1.218Z",
    transform: "translate(-503.832 -2009.021)",
    fill: "#fc9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11693",
    "data-name": "Trac\\xE9 11693",
    d: "M2789.582,893.438l5.82,2.886a5.622,5.622,0,0,1,1.539,8.951l-3.271,4.8a22.028,22.028,0,0,1-7.118,6.637l.289,4.233a8.186,8.186,0,0,1-2.021,5.964l-12.326,10.6.771,6.172a20.959,20.959,0,0,1-.673,9.539c-1.1,1.174-3.9.555-4.272-.448l-3.885-16.8,1.437-4.731.55-8.362,8.525-8.278,2.371-9.326.192-3.756a12.935,12.935,0,0,1,2.886-7.5Z",
    transform: "translate(-532.867 -845.146)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11694",
    "data-name": "Trac\\xE9 11694",
    d: "M3132.722,1122.333c-.058.066-.118.131-.179.194l-3.271,4.8a22.035,22.035,0,0,1-7.119,6.637,4.837,4.837,0,0,0-2.348-7.416l-2.937-1.006,5.015-3.9h.788C3124.959,1121.646,3129.562,1121.289,3132.722,1122.333Z",
    transform: "translate(-868.468 -1062.399)",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11695",
    "data-name": "Trac\\xE9 11695",
    d: "M3030.089,917.551l.2-.768.192-3.756a12.931,12.931,0,0,1,2.886-7.5l-.489,1.642a3.276,3.276,0,0,0,1.574,3.813,7.718,7.718,0,0,0,3.035.911,13.93,13.93,0,0,0,4.932-.466l1.186,4.165Z",
    transform: "translate(-785.834 -856.654)",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11696",
    "data-name": "Trac\\xE9 11696",
    d: "M2785.393,1356.729l.986-11.893,8.525-8.278.1,4.5Z",
    transform: "translate(-552.824 -1267.103)",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11697",
    "data-name": "Trac\\xE9 11697",
    d: "M2836.023,1000.345H2833.4a6.025,6.025,0,0,0-4.732,2.3l-6.878,1.821-1.271-.171a14.015,14.015,0,0,0-7.151.91l-6.794,1.93.364,1.94,2.355.891a17.612,17.612,0,0,0,12.1.133h2.276a20.462,20.462,0,0,0,7.048-1.252l2.342.456a4.754,4.754,0,0,0,5.421-3.174C2839.234,1003.853,2838.18,1000.345,2836.023,1000.345Z",
    transform: "translate(-572.997 -946.947)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3411",
    "data-name": "Groupe 3411",
    transform: "translate(2204.843 5.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11698",
    "data-name": "Trac\\xE9 11698",
    d: "M2256.764,7.174l-8.213,3.713a83.641,83.641,0,0,0-43.708,46.439l.456,6.714a58.666,58.666,0,0,0,25.369,44.424l3.578-36.585L2246.12,32.7Z",
    transform: "translate(-2204.843 -7.113)",
    fill: "#ffa1a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11699",
    "data-name": "Trac\\xE9 11699",
    d: "M2248.137,88.892a83.641,83.641,0,0,0-43.294,46.249l.456,6.714a58.667,58.667,0,0,0,14.944,35.3,73.6,73.6,0,0,1-1.963-51.4A67.809,67.809,0,0,1,2248.137,88.892Z",
    transform: "translate(-2204.843 -84.929)",
    fill: "#ffb8b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11700",
    "data-name": "Trac\\xE9 11700",
    d: "M2332.51,477.2a83.642,83.642,0,0,0-11.872,16,117.479,117.479,0,0,0,22.971,35.46l.9-9.206,5.639-18.6A83.74,83.74,0,0,1,2332.51,477.2Z",
    transform: "translate(-2315.108 -454.697)",
    fill: "#f66",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11701",
    "data-name": "Trac\\xE9 11701",
    d: "M2332.51,477.2a83.642,83.642,0,0,0-11.872,16,118.128,118.128,0,0,0,5.5,11.422,70.194,70.194,0,0,1,2.409-9.116,68.672,68.672,0,0,1,6.423-13.773Q2333.672,479.512,2332.51,477.2Z",
    transform: "translate(-2315.108 -454.697)",
    fill: "#ff8787",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11702",
    "data-name": "Trac\\xE9 11702",
    d: "M2748.156,118.119a1.607,1.607,0,0,1-3.214.063l-.227-10.927A197.183,197.183,0,0,1,2769.843,6.729a1.611,1.611,0,1,1,2.81,1.575,194.066,194.066,0,0,0-24.725,98.888Z",
    transform: "translate(-2718.891 -5.905)",
    fill: "#b82e2e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11703",
    "data-name": "Trac\\xE9 11703",
    d: "M2259.411,789.43c-7.063-2.5-14.47-8.449-19.616-16.223-4.484-6.773-7.271-14.948-6.651-23.467a4.881,4.881,0,0,1,5.946-4.408q-.633,1-1.237,2.029a2.732,2.732,0,0,0-2.567,2.53c-.582,8.009,2.056,15.723,6.3,22.131,4.891,7.389,11.89,13.026,18.541,15.383Z",
    transform: "translate(-2231.711 -709.904)",
    fill: "#b82e2e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11704",
    "data-name": "Trac\\xE9 11704",
    d: "M3206.063,857.652l.868-2.3c2.236-.484,3.733-.423,5.671,1.579l-.254,2.93Z",
    transform: "translate(-953.403 -808.634)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11705",
    "data-name": "Trac\\xE9 11705",
    d: "M3201.965,653.263c4.733,0,4.733,3.846,4.733,7.265s-3.8,5.118-4.733,5.118-4.733-1.7-4.733-5.118S3197.232,653.263,3201.965,653.263Z",
    transform: "translate(-944.994 -616.441)",
    fill: "#fc9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11706",
    "data-name": "Trac\\xE9 11706",
    d: "M3261.939,851.333a1.844,1.844,0,0,1-3.633,0Z",
    transform: "translate(-1003.152 -805.052)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11707",
    "data-name": "Trac\\xE9 11707",
    d: "M3190.208,616.035l.515-2.779a2.726,2.726,0,0,0-1.423-2.915l-.178-.784-.106-.107a4.288,4.288,0,0,0-2.728-1.245,6.852,6.852,0,0,0-5.951,2.7,2,2,0,0,0-.178,2.134l.213,1.209q.2,1.12.392,2.241l.416-2.313,1.9-.142a12.7,12.7,0,0,0,6.028-1.7A6.165,6.165,0,0,1,3190.208,616.035Z",
    transform: "translate(-928.521 -573.519)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3412",
    "data-name": "Groupe 3412",
    transform: "translate(2253.301 41.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11708",
    "data-name": "Trac\\xE9 11708",
    d: "M3316.307,742.649v1.014l1.672-.1a2.556,2.556,0,0,1,.882.1l.162-.6a2.686,2.686,0,0,0-1.4-.406Z",
    transform: "translate(-3311.683 -742.649)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11709",
    "data-name": "Trac\\xE9 11709",
    d: "M3323.472,773.419a.755.755,0,1,0-.6-.74A.684.684,0,0,0,3323.472,773.419Z",
    transform: "translate(-3317.931 -770.54)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11710",
    "data-name": "Trac\\xE9 11710",
    d: "M3222.216,742.649v1.014l-1.673-.1a2.554,2.554,0,0,0-.882.1l-.162-.6a2.686,2.686,0,0,1,1.4-.406Z",
    transform: "translate(-3219.499 -742.649)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11711",
    "data-name": "Trac\\xE9 11711",
    d: "M3245.1,773.419a.755.755,0,1,0-.6-.74A.684.684,0,0,0,3245.1,773.419Z",
    transform: "translate(-3243.299 -770.54)",
    fill: "#333",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe3413);
export default __webpack_public_path__ + "static/media/Groupe 3413.ae3d84b6dd49d139d1c3d6eb20eb3d8b.svg";
export { ForwardRef as ReactComponent };